import React, { useEffect, useState, useCallback } from 'react';
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, IconButton, CircularProgress, Popover, MenuItem, ListItemIcon, ListItemText, FormControl, InputLabel, Select, FormControlLabel, Checkbox, MenuItem as SelectMenuItem, Card, CardHeader, CardContent } from "@mui/material"
import { PetModal } from "./PetModal"
import { Controller, useForm } from "react-hook-form"
import { toast } from "react-toastify"
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { PetAPI } from '../api/PetAPI';
import { OwnerAPI } from '../api/OwnerAPI';
import ConfirmButton from './ConfirmButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Container } from '../components/Container';
import { FilterPet } from './FilterPet';

export const PetSpaceComponent = () => {
    const [selectedPet, setSelectedPet] = useState(null);
    const [openModalPet, setOpenModalPet] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [rowsPet, setRowsPet] = useState([]);
    const [owners, setOwners] = useState([]);

    const [loading, setLoading] = useState({
        create: false,
        edit: false,
        delete: false,
        loadData: false
    });

    const defaultValuesPet = {
        id: '',
        name: '',
        breed: '',
        color: '',
        size: '',
        weight: '',
        age: '',
        birth_date: '',
        gender: '',
        neutered: false,
        owner_id: '',
    }

    const methodsPet = useForm({ defaultValues: defaultValuesPet });

    const loadData = useCallback(async (data) => {
        setLoading(prev => ({ ...prev, loadData: true }));
        const petsResponse = await PetAPI.getPets(data);
        if (petsResponse.success) {
            setRowsPet(petsResponse.data.pets || []);
        } else {
            toast.error(petsResponse.message || "Erro ao carregar pets");
        }
        const ownersResponse = await OwnerAPI.getOwners();
        if (ownersResponse.success) {
            setOwners(ownersResponse.data.owners || []);
        }

        setLoading(prev => ({ ...prev, loadData: false }));
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleClick = (event, pet) => {
        setAnchorEl(event.currentTarget);
        setSelectedPet(pet);
    };

    const handleClosePet = () => {
        setAnchorEl(null);
        setSelectedPet(null);
    }

    async function submitPet(data) {
        setLoading({ ...loading, create: true });
        const pet = {
            name: data.name,
            breed: data.breed,
            color: data.color,
            size: data.size,
            weight: data.weight,
            age: data.age,
            birth_date: data.birth_date,
            gender: data.gender,
            neutered: data.neutered,
            owner_id: data.owner_id
        }

        const response = await PetAPI.createPet(pet);

        if (response.success) {
            toast.success(response.message || "Pet criado com sucesso");
            setOpenModalPet(false);
            methodsPet.reset(defaultValuesPet);
            loadData();
        } else {
            toast.error(response.message || "Erro ao criar pet");
        }
        setLoading({ ...loading, create: false });
    }

    const handleSubmitEditPet = async (data) => {
        setLoading({ ...loading, edit: true });
        const body = {
            name: data.name,
            breed: data.breed,
            color: data.color,
            size: data.size,
            weight: data.weight,
            age: data.age,
            birth_date: data.birth_date,
            gender: data.gender,
            neutered: data.neutered,
            owner_id: data.owner_id
        }
        const response = await PetAPI.updatePet(data.guid, body);
        if (response.success) {
            toast.success(response.message || 'Pet atualizado com sucesso');
            setOpenModalPet(false);
            methodsPet.reset(defaultValuesPet);
            loadData();
        } else {
            toast.error(response.message || 'Erro ao atualizar pet');
        }
        setLoading({ ...loading, edit: false });
    }

    const handleEditPet = async (pet) => {

        setLoading({ ...loading, edit: true });
        const response = await PetAPI.getPetById(pet.guid);
        if (response.success) {
            methodsPet.setValue('guid', response.data.pet.guid);
            methodsPet.setValue('id', response.data.pet.id);
            methodsPet.setValue('name', response.data.pet.name);
            methodsPet.setValue('breed', response.data.pet.breed);
            methodsPet.setValue('color', response.data.pet.color);
            methodsPet.setValue('size', response.data.pet.size);
            methodsPet.setValue('weight', response.data.pet.weight);
            methodsPet.setValue('age', response.data.pet.age);
            methodsPet.setValue('birth_date', response.data.pet.birth_date);
            methodsPet.setValue('gender', response.data.pet.gender);
            methodsPet.setValue('neutered', response.data.pet.neutered);
            methodsPet.setValue('owner_id', response.data.pet.owner_id);


        }
        setIsEditing(true);
        setOpenModalPet(true);
        setLoading({ ...loading, edit: false });
    }

    const handleDeletePet = async (pet) => {
        setLoading({ ...loading, delete: true });
        const response = await PetAPI.deletePet(pet.guid);
        if (response.success) {
            toast.success(response.message || 'Pet excluído com sucesso');
            loadData();
        }
        setLoading({ ...loading, delete: false });
    }

    const getOwnerName = (ownerId) => {
        const owner = owners.find(o => o.id === ownerId);
        return owner ? owner.name : 'Sem dono';
    }

    return (
        <>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClosePet}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: {
                        minWidth: 120,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                    }
                }}
            >
                <MenuItem
                    onClick={() => {
                        handleEditPet(selectedPet);
                        handleClosePet();
                    }}
                    sx={{ py: 1 }}
                >
                    <ListItemIcon>
                        <EditIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Editar</ListItemText>
                </MenuItem>
                <MenuItem
                    sx={{ py: 1, color: 'error.main', p: 0 }}
                >
                    <ConfirmButton
                        title="Excluir Pet"
                        message={`Tem certeza que deseja excluir o pet "${selectedPet?.name}"? Esta ação não pode ser desfeita.`}
                        confirmText="Excluir"
                        cancelText="Cancelar"
                        confirmColor="error"
                        variant="text"
                        size="small"
                        onConfirm={() => handleDeletePet(selectedPet)}
                        onCancel={handleClosePet}
                        sx={{
                            width: '100%',
                            justifyContent: 'flex-start',
                            color: 'error.main',
                            textTransform: 'none',
                            p: 1.5
                        }}
                    >
                        <Box display="flex" alignItems="center" className="gap-1">
                            <DeleteIcon />
                            <Typography>
                                Excluir
                            </Typography>
                        </Box>
                    </ConfirmButton>
                </MenuItem>
            </Popover>

            <PetModal
                open={openModalPet}
                onClose={() => {
                    setOpenModalPet(false);
                    setIsEditing(false);
                    methodsPet.reset(defaultValuesPet);
                }}
                title={isEditing ? "Editar Pet" : "Novo Pet"}
                size={'middle'}
                formId='pet-form'
                loading={isEditing ? loading.edit : loading.create}
            >
                <form id='pet-form' onSubmit={methodsPet.handleSubmit(isEditing ? handleSubmitEditPet : submitPet)}>
                    <Box display='flex' flexDirection='column' className='gap-2'>
                        <TextField
                            id="name"
                            label="Nome"
                            variant="outlined"
                            name="name"
                            {...methodsPet.register("name")}
                            required
                        />
                        <TextField
                            id="breed"
                            label="Raça"
                            variant="outlined"
                            name="breed"
                            {...methodsPet.register("breed")}
                            required
                        />
                        <TextField
                            id="color"
                            label="Cor"
                            variant="outlined"
                            name="color"
                            {...methodsPet.register("color")}
                            required
                        />
                        <Controller
                            name="size"
                            control={methodsPet.control}
                            render={({ field }) => (
                                <FormControl variant="outlined">
                                    <InputLabel id="size-label">Porte</InputLabel>
                                    <Select
                                        {...field}
                                        labelId="size-label"
                                        id="size"
                                        name="size"
                                        label="Porte"
                                    >
                                        <SelectMenuItem value="pequeno">Pequeno</SelectMenuItem>
                                        <SelectMenuItem value="medio">Médio</SelectMenuItem>
                                        <SelectMenuItem value="grande">Grande</SelectMenuItem>
                                    </Select>
                                </FormControl>
                            )}
                        />
                        <TextField
                            id="weight"
                            label="Peso (kg)"
                            variant="outlined"
                            name="weight"
                            type="number"
                            {...methodsPet.register("weight")}
                        />
                        <TextField
                            id="age"
                            label="Idade"
                            variant="outlined"
                            name="age"
                            {...methodsPet.register("age")}
                        />
                        <TextField
                            id="birth_date"
                            label="Data de Nascimento"
                            variant="outlined"
                            name="birth_date"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            {...methodsPet.register("birth_date")}
                        />
                        <Controller
                            name="gender"
                            control={methodsPet.control}
                            render={({ field }) => (
                                <FormControl variant="outlined">
                                    <InputLabel id="gender-label">Sexo</InputLabel>
                                    <Select
                                        {...field}
                                        labelId="gender-label"
                                        id="gender"
                                        label="Sexo"
                                    >
                                        <MenuItem value="macho">Macho</MenuItem>
                                        <MenuItem value="femea">Fêmea</MenuItem>
                                    </Select>
                                </FormControl>
                            )}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="neutered"
                                    onChange={(e) => methodsPet.setValue("neutered", e.target.checked)}
                                    checked={methodsPet.watch("neutered")}
                                />
                            }
                            label="Castrado"
                        />
                        <Controller
                            name="owner_id"
                            control={methodsPet.control}
                            render={({ field }) => (
                                <FormControl variant="outlined">
                                    <InputLabel id="owner-label">Dono</InputLabel>
                                    <Select
                                        {...field}
                                        labelId="owner-label"
                                        id="owner_id"
                                        label="Dono"
                                    >
                                        {owners.map((owner) => (
                                            <MenuItem key={owner.id} value={owner.id}>
                                                {owner.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}
                        />
                    </Box>
                </form>
            </PetModal>

            <Box marginBottom="10px" width="100%" display="flex" justifyContent="flex-end" className="gap-1">
                <Button
                    style={{ textTransform: "none" }}
                    color="primary"
                    variant="contained"
                    onClick={() => {
                        setIsEditing(false);
                        methodsPet.reset(defaultValuesPet);
                        setOpenModalPet(true);
                    }}
                >
                    <Typography>
                        Novo Pet
                    </Typography>
                </Button>
                <FilterPet onFilter={loadData} owners={owners} />

            </Box>

            <Box display={{ xs: 'block', sm: 'none' }}>
                {loading.loadData ? (
                    <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
                        <CircularProgress size={20} />
                    </Box>
                ) : rowsPet.length === 0 ? (
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="200px" sx={{ color: '#9CA3AF' }}>
                        <Typography variant="body1" sx={{ color: '#6B7280' }}>
                            Nenhum pet encontrado
                        </Typography>
                    </Box>
                ) : (
                    rowsPet.map((row) => (
                        <Card key={row.id} sx={{ mb: 2, borderRadius: 2, boxShadow: 3 }}>
                            <CardHeader
                                title={
                                    <Typography variant="subtitle1" fontWeight={600}>
                                        {row.name}
                                    </Typography>
                                }
                                action={
                                    <IconButton
                                        onClick={(event) => handleClick(event, row)}
                                        size="small"
                                    >
                                        <MoreHorizIcon />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Typography variant="body2" sx={{ color: '#6B7280' }}>
                                        Raça:
                                    </Typography>
                                    <Typography variant="body2">
                                        {row.breed}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Typography variant="body2" sx={{ color: '#6B7280' }}>
                                        Cor:
                                    </Typography>
                                    <Typography variant="body2">
                                        {row.color}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Typography variant="body2" sx={{ color: '#6B7280' }}>
                                        Porte:
                                    </Typography>
                                    <Typography variant="body2">
                                        {row.size}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Typography variant="body2" sx={{ color: '#6B7280' }}>
                                        Peso:
                                    </Typography>
                                    <Typography variant="body2">
                                        {row.weight ? `${row.weight} kg` : '-'}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Typography variant="body2" sx={{ color: '#6B7280' }}>
                                        Idade:
                                    </Typography>
                                    <Typography variant="body2">
                                        {row.age || '-'}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Typography variant="body2" sx={{ color: '#6B7280' }}>
                                        Sexo:
                                    </Typography>
                                    <Typography variant="body2">
                                        {row.gender || '-'}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <Typography variant="body2" sx={{ color: '#6B7280' }}>
                                        Castrado:
                                    </Typography>
                                    <Typography variant="body2">
                                        {row.neutered ? 'Sim' : 'Não'}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography variant="body2" sx={{ color: '#6B7280' }}>
                                        Dono:
                                    </Typography>
                                    <Typography variant="body2">
                                        {getOwnerName(row.owner_id)}
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    ))
                )}
            </Box>

            <Box display={{xs:'none' , sm:'block'}} >
                <Container>
                    <Box display={{ xs: 'none', sm: 'block' }}>
                        {loading.loadData ? (
                            <Box display='flex' justifyContent='center' alignItems='center' height='100%'>
                                <CircularProgress size={20} />
                            </Box>
                        ) : (
                            <TableContainer component={Paper}>
                                <Table sx={{ width: '100%', height: '100%', overflowY: 'auto' }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Nome</TableCell>
                                            <TableCell>Raça</TableCell>
                                            <TableCell>Cor</TableCell>
                                            <TableCell>Porte</TableCell>
                                            <TableCell>Peso</TableCell>
                                            <TableCell>Idade</TableCell>
                                            <TableCell>Sexo</TableCell>
                                            <TableCell>Castrado</TableCell>
                                            <TableCell>Dono</TableCell>
                                            <TableCell align="right">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {rowsPet.length > 0 ? (
                                            rowsPet.map((row, index) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {row.name}
                                                    </TableCell>
                                                    <TableCell>{row.breed}</TableCell>
                                                    <TableCell>{row.color}</TableCell>
                                                    <TableCell>{row.size}</TableCell>
                                                    <TableCell>{row.weight ? `${row.weight} kg` : '-'}</TableCell>
                                                    <TableCell>{row.age || '-'}</TableCell>
                                                    <TableCell>{row.gender || '-'}</TableCell>
                                                    <TableCell>{row.neutered ? 'Sim' : 'Não'}</TableCell>
                                                    <TableCell>{getOwnerName(row.owner_id)}</TableCell>
                                                    <TableCell align="right">
                                                        <IconButton
                                                            onClick={(event) => handleClick(event, row)}
                                                            size="small"
                                                        >
                                                            <MoreHorizIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={10} align="center">
                                                    {loading.loadData ? (
                                                        <CircularProgress size={20} />
                                                    ) : (
                                                        'Nenhum pet encontrado'
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </Box>
                </Container>
            </Box>
        </>
    )
}
